import request from '../../utils/request';

export function getPartnerOrders(params) {
  return request('/orders/partner-orders', {
    method: 'GET',
    params: params,
  });
}
